<main class="comercial">
  <header>
    <div><a routerLink="/admin/mia-gestor">Mia Gestor</a><h1>Atendimento comercial</h1>
      <p>Do primeiro interesse ao próximo passo com o restaurante.</p></div>
    <button type="button" (click)="atualize()" [disabled]="carregando">{{ carregando ? 'Atualizando…' : 'Atualizar' }}</button>
  </header>
  <p class="erro" role="alert" *ngIf="erro">{{ erro }}</p>
  <div class="layout">
    <aside aria-label="Interessados">
      <label for="busca-comercial">Buscar interessado</label>
      <input id="busca-comercial" [(ngModel)]="filtro" placeholder="Nome, telefone ou motivo">
      <p class="vazio" *ngIf="!atendimentos.length && !carregando">Os atendimentos recebidos pelo número de teste aparecerão aqui.</p>
      <p class="vazio" *ngIf="atendimentos.length && !filtrados.length">Nenhum atendimento para esta busca.</p>
      <button class="contato" type="button" *ngFor="let item of filtrados" (click)="abra(item.atendimentoId)"
              [class.selecionado]="selecionado?.atendimentoId === item.atendimentoId" [disabled]="salvando">
        <strong>{{ item.nome || item.waId }}</strong><small>{{ item.waId }}</small>
        <span class="pedido" *ngIf="item.encaminhamento">{{ item.encaminhamento.status === 'OPT_OUT' ? 'Pediu para parar' : 'Pedido para a equipe' }}</span>
        <span class="previa">{{ item.ultimaMensagem }}</span>
        <small>{{ item.ultimaInteracao | date:'dd/MM HH:mm' }}</small>
        <small *ngIf="item.ultimaEntrega === 'ENVIO_INCERTO' || item.ultimaEntrega === 'PROCESSANDO'">Entrega precisa de verificação</small>
      </button>
    </aside>
    <section class="detalhe" aria-live="polite">
      <p class="vazio" *ngIf="abrindo">Abrindo conversa…</p>
      <p class="vazio" *ngIf="!selecionado && !abrindo">Escolha um interessado para ver o histórico e continuar o atendimento.</p>
      <ng-container *ngIf="selecionado">
        <div class="cabecalho-conversa">
          <div><h2>{{ selecionado.nome || selecionado.waId }}</h2><p>{{ estado }}</p></div>
          <div class="acoes">
            <button type="button" (click)="controle('humano')" [disabled]="salvando || selecionado.controle?.pausada">Assumir conversa</button>
            <button type="button" (click)="controle('devolver')" [disabled]="salvando || !selecionado.controle?.pausada || selecionado.controle?.bloqueada">Devolver à Mia</button>
            <button type="button" (click)="controle('bloquear')" [disabled]="salvando || selecionado.controle?.bloqueada">Desativar Mia</button>
          </div>
        </div>
        <p class="encaminhamento" *ngIf="selecionado.encaminhamento"><strong>Pedido para a equipe:</strong> {{ selecionado.encaminhamento.motivo }}</p>
        <p class="orientacao">Ao assumir, continue pelo WhatsApp empresarial conectado. A Mia fica pausada conforme a configuração de atendimento da empresa.</p>
        <details class="ficha" open>
          <summary>O que já sabemos · {{ fatos.length }} informações</summary>
          <p *ngIf="!fatos.length">A Mia ainda não registrou informações de qualificação.</p>
          <dl *ngFor="let fato of fatos"><dt>{{ fato.campo }}</dt><dd>{{ fato.valor }}
            <blockquote>“{{ fato.evidencia }}”</blockquote><small>Mensagem #{{ fato.turnoId }} · {{ fato.registradoEm | date:'dd/MM HH:mm' }}</small>
          </dd></dl>
        </details>
        <div class="mensagens" aria-label="Histórico da conversa">
          <article *ngFor="let mensagem of selecionado.mensagens" [class.mia]="mensagem.papel === 'gestor'">
            <small>{{ mensagem.papel === 'gestor' ? 'Mia' : mensagem.papel === 'usuario' ? 'Interessado' : 'Sistema' }} · {{ mensagem.criadoEm | date:'dd/MM HH:mm' }}</small>
            <p>{{ mensagem.texto }}</p>
          </article>
        </div>
      </ng-container>
    </section>
  </div>
</main>
